import {useSelector,useDispatch} from 'react-redux'
import {
	getInvoices,
	selectAllInvoices,
	selectInvoiceIds,
	selectInvoiceById
} from './slice'
import {slidingEditDistance} from '../../../util/util'

export const useInvoices = ()=>{
	const dispatch = useDispatch()
	const status = useSelector(state=>state.invoices.status)
	const {order} = useSelector(state=>state.invoices.sort)
	const {query} = useSelector(state=>state.invoices.filter)
	const invoices = useSelector(selectAllInvoices).sort((a,b)=>{
		//integer date values
		const aVal = new Date(a.date_created.split(' ').join('T')).getTime()
		const bVal = new Date(b.date_created.split(' ').join('T')).getTime()
		//the sort value to use if there is no search query 
		const nonQueryVal = (
			order === 'desc'
			? bVal - aVal
			: aVal - bVal
		)
		//get the "name" to use for the search query
		//for non-clients use the email else use the client's username
		const aName = String(
			a.non_client
			? a.recipient_email
			: a.recipient.user_name
		).toLowerCase()
		const bName = String(
			b.non_client
			? b.recipient_email
			: b.recipient.user_name
		).toLowerCase()
		const q = query.toLowerCase()
		const {dist:aDist,offset:aOffset} = slidingEditDistance(aName,q)
		const {dist:bDist,offset:bOffset} = slidingEditDistance(bName,q)
		const queryVal = (
			Boolean(query)
			? (aDist -  bDist || aOffset - bOffset)
			: 0
		)
		return queryVal || nonQueryVal
	})
	const ids = invoices.map(i=>i.id)

	if (status==='init') dispatch(getInvoices())

	return {status,invoices,ids}
}

export const useInvoice = (id)=>useSelector(state=>id&&selectInvoiceById(state,id))